import { FormInput, type FormInputProps } from "@prismicio/editor-ui"
import { useEffect, useState } from "react"

import {
  RequestFormInputBase,
  type RequestFormInputBaseProps,
} from "./RequestFormInputBase"

export type RequestFormMultiInputProps = Pick<
  RequestFormInputBaseProps,
  "label"
> &
  FormMultiInputProps

export function RequestFormMultiInput(props: RequestFormMultiInputProps) {
  const { label, ...restProps } = props

  return (
    <RequestFormInputBase label={label}>
      <FormMultiInput size="medium" {...restProps} />
    </RequestFormInputBase>
  )
}

export type FormMultiInputProps = Omit<
  FormInputProps,
  "value" | "onValueChange"
> & {
  value: string[]
  onValueChange: (values: string[]) => void
}

export function FormMultiInput(props: FormMultiInputProps) {
  const { value, onValueChange, ...restProps } = props

  // Local "string" state of the input value
  const [inputValue, setInputValue] = useState(() => value.join(", "))

  // Keep local state in sync with the external value
  useEffect(() => {
    setInputValue(value.join(", "))
  }, [value])

  function handleValueChange(stringValue: string) {
    setInputValue(stringValue)

    const newValue = stringValue
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean)

    // Only call onValueChange if the array actually changed
    // (allows for adding new values by typing comma separated values)
    if (JSON.stringify(newValue) !== JSON.stringify(value)) {
      onValueChange(newValue)
    }
  }

  return (
    <FormInput
      {...restProps}
      value={inputValue}
      onValueChange={handleValueChange}
    />
  )
}
